import React, { useEffect, useState } from "react";
import Icon from "../../../components/AppIcon";
import api from "../../../api/axiosInstance";

const PlatformFeatures = () => {
  const [features, setFeatures] = useState([]);

  useEffect(() => {
    const fetchFeatures = async () => {
      try {
        const res = await api.get("/api/platform-features", {
          params: { page: "home" },
        });
        setFeatures(res.data || []);
      } catch (err) {
        console.error("Failed to load platform features", err);
      }
    };

    fetchFeatures();
  }, []);

  if (!features.length) return null;

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-4">
            <Icon name="Sparkles" size={16} />
            <span className="font-medium">Platform Features</span>
          </div>

          <h2 className="text-3xl font-bold mb-4">
            Everything You Need to Succeed
          </h2>

          <p className="text-muted-foreground max-w-3xl mx-auto">
            Our comprehensive platform provides all the tools and resources you
            need to master your interview skills
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature._id}
              className="bg-card rounded-xl p-6 shadow-md border border-border"
            >
              <div
                className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
                style={{ backgroundColor: `${feature.color}15` }}
              >
                <Icon
                  name={feature.icon}
                  size={24}
                  color={feature.color}
                />
              </div>

              <h3 className="text-lg font-bold mb-2">
                {feature.title}
              </h3>

              <p className="text-muted-foreground text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PlatformFeatures;
